import { render, staticRenderFns } from "./FreemiumCard.vue?vue&type=template&id=f4f445d8"
import script from "./FreemiumCard.vue?vue&type=script&lang=js"
export * from "./FreemiumCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports